module.exports = __webpack_public_path__ + "img/pluslife.8e30614d.png";